// extracted by mini-css-extract-plugin
export default {"distributionContainer":"Distribution_distributionContainer__hea4p","header":"Distribution_header__ARUdw","actionButtons":"Distribution_actionButtons__B1mp+"};